<template>
  <div class="container-custom">
    <Breadscrumbs
      :links="[{ name: 'Privacy', to: { path: '/privacy' } }]"
    ></Breadscrumbs>
    <div class="page-actions">
      <h2>Privacy</h2>
      <v-spacer></v-spacer>
      <button class="btn" @click="editHandler">
        <v-icon class="mr-2">edit</v-icon>
        <span>編輯</span>
      </button>
    </div>
    <!-- block -->
    <div class="block mb-5">
      <!-- Page Tilte -->
      <label class="form-item py-5 d-flex">
        <div class="w-240px mr-5"><h4>Page Tilte</h4></div>
        <div class="flex-grow-1 flex-basis-0">{{ privacy }}</div>
      </label>
      <!-- Image -->
      <div class="form-item d-flex px-5 py-5">
        <div class="w-240px mr-5">
          <h4 class="mb-10px">Image</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <div
            class="w-280px h-187px bg-cover bg-center"
            :style="{
              'background-image': `url(${image})`,
              'border-radius': '8px',
            }"
          ></div>
        </div>
      </div>
    </div>

    <div class="page-divider mb-5"></div>

    <!-- content -->
    <div class="d-flex">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Content</h3>
        <div class="h4">
          至少需填寫一組內容 <br />
          可添加欄位做內容擴充
        </div>
      </div>
      <!-- content body -->
      <div class="flex-grow-1">
        <div class="block mb-5" v-for="item in itemList" :key="item.id">
          <!-- content -->
          <div
            class="form-item py-5 d-flex align-center justify-lg-space-between"
          >
            <h4>Content</h4>
          </div>
          <!-- Section Tabs -->
          <div class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="flex-grow-1 flex-basis-0">
              {{ item.sectionTabs }}
            </div>
          </div>
          <!-- Title -->
          <div class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="flex-grow-1 flex-basis-0">
              {{ item.title }}
            </div>
          </div>
          <!-- Description -->
          <div class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div
              class="flex-grow-1 flex-basis-0"
              v-html="item.description"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadscrumbs from '@/components/Breadscrumbs.vue';

export default {
  components: {
    Breadscrumbs,
  },
  data: () => ({
    privacy: 'PageTitle',
    image: 'https://dummyimage.com/240x187.jpg',
    itemList: [
      {
        id: '001',
        sectionTabs: 'Tab Label',
        title: 'title 01',
        description: `• 270˚ wide beam bulb <br>
          • Enhanced heat dissipation <br>
          • High efficiency traditional bulb replacement
        `,
      },
      {
        id: '002',
        sectionTabs: 'Tab Label',
        title: 'title 02',
        description: 'content 02',
      },
    ],
  }),
  methods: {
    editHandler() {
      this.$router.push('/privacy/edit');
    },
  },
};
</script>

<style></style>
